import { getScreenIdFromElement } from "../controls/screenUtil";
import { ll } from "../core/ll";

$.fn.extend({
    getLabelFor: function () {
        if (!this.length) {
            return null;
        }

        var result = getScreenIdFromElement(this),
            screenId = result.screenId,
            elementId = result.elementId;

        var labelForId = screenId
            ? $("[data-label-for-id='{0}_{1}']".format(screenId, elementId)).text()
            : $("[data-label-for-id='{0}']".format(elementId)).text();

        if (labelForId) {
            return labelForId;
        }

        if (screenId) {
            return $("[id^={0}_][data-label-for='{1}']".format(screenId, elementId)).text();
        } else {
            return $("[data-label-for='{0}']".format(elementId)).text();
        }
    },
    zValidator: function (options) {
        options = options || {};

        if (this[0]) {
            options.screenEntityType = this[0].getAttribute("screenEntityType");
        }

        options.errorTemplate = options.errorTemplate || "";
        options.messages = options.messages || {
            "required": "",
            "max-length": "",
            "nan": "",
            "min-range": "",
            "pattern": ""
        };

        var valid = true;
        var elem;
        var checkFail = function (args) {
            if (elem) {
                if (elem[0].id != args.elem[0].id) {
                    valid = true;
                } else if (elem.context && args.elem.context && elem.context.id != args.elem.context.id) {
                    valid = true;
                }
            }

            if (args.fail) {
                valid = false;
            }

            if (valid) {
                if (args.elem.data("kendoNumericTextBox")) {
                    args.elem.parent().removeClass("validation-failure");
                } else {
                    args.elem.removeClass("validation-failure");
                }

            } else {
                if (args.elem.data("kendoNumericTextBox")) {
                    args.elem.parent().addClass("validation-failure");
                } else {
                    args.elem.addClass("validation-failure");
                }
            }
            elem = args.elem;
        };

        options.rules = options.rules || {
            "required": function (input) {
                var me = options.validator;
                me.validationErrors = me.validationErrors || {};
                me.validationErrors.required = me.validationErrors.required || {};
                if (input.is("[required]")) {
                    var data = input.data && input.data();
                    var element = input;
                    if (data) {
                        $.each(data, function (index, value) {
                            if (value && value.wrapper) {
                                element = value.wrapper;
                                return false;
                            }
                        });
                    }

                    var isEmpty = $.trim(input.val()) === "",
                        zData = element.data("me"),
                        name = "",
                        objectField = name,
                        bindValue = "";

                    if (!zData && element.context) {
                        zData = $(element.context).data("me");
                    }

                    if (zData) {
                        if (!zData.options.bindValue) {
                            zData.options.bindValue = element.attr("data-bind");
                        }
                        bindValue = zData.options.bindValue;
                        if (!bindValue) {
                            bindValue = zData.options.label;
                        }
                        if (bindValue.indexOf(":") != -1) {
                            bindValue = $.trim(bindValue.substring(bindValue.indexOf(":") + 1));
                        }
                        bindValue = bindValue.replaceAll(".", "_");

                        if ((ll(bindValue, true) && ll(bindValue, true).indexOf("Id") != 1) || ll(bindValue, true) == null) {
                            bindValue = bindValue.replace(/Id$/, "");
                        }

                        name = ll(bindValue, true);
                        objectField = bindValue;
                    } else if (element.hasClass("kendo-edit")) {
                        var parent = element.parents(".k-edit-field");
                        var editLabel = parent.prev(".k-edit-label");
                        if (editLabel.text()) {
                            name = editLabel.text();
                            objectField = name.replace(/ /g, "");
                        }
                    } else if (element.data("bind")) {
                        bindValue = element.data("bind");
                        if (bindValue.indexOf(":") != -1) {
                            bindValue = $.trim(bindValue.substring(bindValue.indexOf(":") + 1));
                        }
                        bindValue = bindValue.replaceAll(".", "_");
                        objectField = bindValue;
                    }

                    var labelText;

                    if (options.localizedField) {
                        name = options.localizedField;
                        objectField = name.replace(/ /g, "");
                    } else {
                        var child = element.find("input");
                        if (child && (child.hasClass("k-input") || child.attr("data-role") == "colorpicker")) {
                            let row = child.closest(".row");
                            if (row) {
                                let label = row.find(".bind-label");

                                labelText = label.text();
                            }
                            if ((child.attr("data-role") == "colorpicker") && !child.data("kendoColorPicker").value()) {
                                isEmpty = true;
                            }
                        } else if (element.attr("type") == "text") {
                            let row = element.closest(".row");
                            if (row) {
                                let label = row.find(".bind-label");

                                labelText = label.text();
                            }
                        }
                    }

                    if (input.hasClass("linked-input")) {
                        objectField = objectField.substring(4);
                    }

                    var noMessage = true;
                    objectField = labelText || ll(objectField, noMessage);

                    var labelFor = input.getLabelFor();
                    if (labelFor) {
                        objectField = labelFor;
                    }

                    if (isEmpty || ($.trim(input.val()) as any == -1 && data.kendoComboBox)) {
                        if (isEmpty && data.kendoComboBox && data.me && data.me.options && data.me.options.entityType == "Division") {
                            return true;
                        }
                        checkFail({ elem: element, fail: true });
                        me.validationErrors.pattern && delete me.validationErrors.pattern[objectField];
                        me.validationErrors.required[objectField] = ll("IsRequiredMessage").format(objectField);
                        isEmpty = true;
                    } else {
                        checkFail({ elem: element, fail: false });
                        if (me.options.retainRequiredValidations !== true) {
                            delete me.validationErrors.required[objectField];
                        }
                    }
                    return !isEmpty;
                }
                return true;
            },
            "nan": function (input) {
                var me = options.validator;
                me.validationErrors = me.validationErrors || {};
                me.validationErrors.nan = me.validationErrors.nan || {};
                var id = input[0].id;
                var element = $("#" + id);
                var data = element.data();
                var bindData;
                if (data && input.is("[nan]")) {
                    bindData = data.bindData;
                    var bind = data.bind.split(" ")[1];
                    if (isNaN(bindData[bind]) && data.kendoNumericTextBox) {
                        me.validationErrors.nan[bind] = ll("NotANumber").format(bind);
                        checkFail({ elem: element, fail: true });
                    } else {
                        checkFail({ elem: element, fail: false });
                        delete me.validationErrors.nan[bind];
                    }
                }

                return true;
            },
            "min-range": function (input) {
                //// Be sure to uncomment the test if we do start using this
                // We don't use this so stop using it until we use ranges,
                // otherwise we are running through it each element for no reason

                // var me = options.validator;
                // me.validationErrors = me.validationErrors || {};
                // me.validationErrors.minRange = me.validationErrors.minRange || {};
                // var schemaValidation = getSchema(input, me.element);
                // var id = input[0].id;
                // var element = $("#" + id);
                // var data = element.data();
                // var bindData;
                // if (data) {
                //     bindData = data["bindData"];
                //     if (bindData && data.bind) {
                //         var bind = data.bind.split(" ")[1];

                //         if (bindData[bind] < input.attr("min-range")) {
                //             checkFail({ elem: element, fail: true });
                //             me.validationErrors.minRange[bind] = z.ll("MinimumMessage").format(bind, input.attr("min-range"));
                //         } else {
                //             checkFail({ elem: element, fail: false });
                //             delete me.validationErrors.minRange[bind];
                //         }
                //     }
                // }

                return true;
            },
            "max-length": function (input) {
                var me = options.validator;
                me.validationErrors = me.validationErrors || {};
                me.validationErrors.maxLength = me.validationErrors.maxLength || {};

                if (input.is("[max-length]")) {
                    var data = input.data && input.data();
                    var element = input;
                    if (data) {
                        $.each(data, function (index, value) {
                            if (value && value.wrapper) {
                                element = value.wrapper;
                                return false;
                            }
                        });
                    }
                    var maxLength = input.attr("max-length");
                    var larger = input.val().length > maxLength,

                        zData = element.data("me"),
                        name = "",
                        objectField = name,
                        bindValue = "";

                    if (zData) {
                        if (!zData.options.bindValue) {
                            zData.options.bindValue = element.attr("data-bind");
                        }
                        bindValue = zData.options.bindValue;
                        if (bindValue.indexOf(":") != -1) {
                            bindValue = $.trim(bindValue.substring(bindValue.indexOf(":") + 1));
                        }
                        bindValue = bindValue.replaceAll(".", "_");
                        objectField = bindValue;
                    } else if (element.hasClass("kendo-edit")) {
                        var parent = element.parents(".k-edit-field");
                        var editLabel = parent.prev(".k-edit-label");
                        if (editLabel.text()) {
                            name = editLabel.text();
                            objectField = name.replace(/ /g, "");
                        }
                    } else if (element.data("bind")) {
                        bindValue = element.data("bind");
                        if (bindValue.indexOf(":") != -1) {
                            bindValue = $.trim(bindValue.substring(bindValue.indexOf(":") + 1));
                        }
                        bindValue = bindValue.replaceAll(".", "_");
                        objectField = bindValue;
                    }

                    if (larger) {
                        checkFail({ elem: element, fail: true });
                        me.validationErrors.maxLength[objectField] = ll("MaxLengthMessage").format(maxLength);
                        return false;
                    } else {
                        checkFail({ elem: element, fail: false });
                        delete me.validationErrors.maxLength[objectField];
                        return true;
                    }
                }
                return true;
            },
            "pattern": function (input) {
                var me = options.validator;
                me.validationErrors = me.validationErrors || {};
                me.validationErrors.pattern = me.validationErrors.pattern || {};
                var id = input[0].id;
                var element = $("#" + id);
                var data = element.data();
                var bindData;
                if (data && input.is("[pattern]")) {
                    bindData = data.bindData;
                    var bind = data.bind.split(" ")[1];
                    var objectField = ll(bind, true);
                    var pattern = new RegExp(data.me.options.pattern);

                    if (!bindData[bind] || bindData[bind].match(pattern)) {
                        checkFail({ elem: element, fail: false });
                        delete me.validationErrors.pattern[objectField];
                    } else {
                        me.validationErrors.pattern[objectField] = ll("PatternMessage").format(pattern);
                        checkFail({ elem: element, fail: true });
                        return false;
                    }
                }

                return true;
            }
        };

        this.kendoValidator(options);

        options.validator = this.data("kendoValidator");
    }
});
